import { lazy } from 'react';

const AdminMessagesRoutes = [
  {
    path: 'messages',
    component: lazy(() => import('views/messages')),
  },
];

export default AdminMessagesRoutes;
